import React, { useEffect, useState } from 'react';
import { Box, Typography, Avatar, Button } from '@mui/material';
import { EditOutlinedIcon, ReplyOutlinedIcon } from 'icons/materialIcons';
import placeholderImage from 'images/placeholder-grey-image.jpg';
import avatarPlaceholder from 'images/avatar-cropped.png';
import { lighten } from '@mui/system';
import ShareYourCardModal from 'components/common/ShareYourCardModal';


const CardComponent = ({ card, onEditCardClick }) => {
  const [fullName, setFullName] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [company, setCompany] = useState('');
  const [coverPhotoUrl, setCoverPhotoUrl] = useState(null);
  const [companyLogoUrl, setCompanyLogoUrl] = useState(null);
  const [profilePictureUrl, setProfilePictureUrl] = useState(null);
  const [cardTheme, setCardTheme] = useState('');
  const [cardName, setCardName] = useState('');
  const lightenedCardTheme = cardTheme ? lighten(cardTheme, 0.7) : '#fff';
  const [shareModalOpen, setShareModalOpen] = useState(false);



  useEffect(() => {
    if (card) {
      setFullName(card.contact_info?.fullName || '');
      setCardName(card.cardName || '');
      setJobTitle(card.contact_info?.jobTitle || '');
      setCompany(card.contact_info?.company || '');
      setCoverPhotoUrl(card.coverPhotoUrl || null);
      setCompanyLogoUrl(card.companyLogoUrl || null);
      setProfilePictureUrl(card.profilePictureUrl || null);
      setCardTheme(card.cardTheme || '');
    }
  }, [card]);

  const handleShareClick = (event) => {
    event.stopPropagation();
    setShareModalOpen(true);

  };

  const getJobTitleAndCompany = () => {
    if (jobTitle && company) {
      return `${jobTitle} at ${company}`;
    }
    return jobTitle || company || '';
  };

  return (
    <Box
      onClick={() => onEditCardClick(card)}
      sx={{
        cursor: 'pointer',
        padding: '5px',
        backgroundColor: lightenedCardTheme || '#fff',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '40%',
        minHeight: '320px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        boxSizing: 'border-box',
        marginRight: '20px',
        marginBottom: '20px',
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '135px',
          backgroundImage: `url(${coverPhotoUrl || placeholderImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
          borderBottomLeftRadius: '10px',
          borderBottomRightRadius: '10px',
          position: 'relative',
          marginBottom: '16px',
        }}
      >
        <Avatar
          src={profilePictureUrl || avatarPlaceholder}
          sx={{
            width: '120px',
            height: '120px',
            backgroundColor: '#ffffff',
            position: 'absolute',
            bottom: '-50px',
            left: '50%',
            transform: 'translateX(-50%)',
            border: '5px solid #ffffff',
          }}
        />

        {companyLogoUrl && (
          <Avatar
            src={companyLogoUrl}
            sx={{
              width: '40px',
              height: '40px',
              position: 'absolute',
              bottom: '-30px',
              right: '40%',
              transform: 'translateX(50%) translateY(25%)',
              backgroundColor: '#ffffff',
            }}
          />
        )}
      </Box>

      <Typography
        variant="h6"
        sx={{
          marginTop: '45px',
          fontSize: '1.1rem',
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#000',
          marginBottom: '5px',
        }}
      >
        {fullName || cardName || 'Card Title'}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          fontSize: '0.8rem',
          color: '#555',
          fontWeight: 600,
          textAlign: 'center',
          marginBottom: '20px',
        }}
      >
        {getJobTitleAndCompany()}
      </Typography>

      <Box sx={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
        <Button
          variant="outlined"
          sx={{
            color: '#b0b0b0',
            borderColor: '#b0b0b0',
            borderRadius: '8px',
            padding: '8px 16px',
            textTransform: 'none',
            display: 'flex',
            alignItems: 'center',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#e0e0e0',
            },
          }}
          startIcon={<EditOutlinedIcon sx={{ color: '#b0b0b0' }} />}
        >
          Edit Card
        </Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#000',
            color: '#fff',
            fontWeight: '500',
            borderRadius: '8px',
            textTransform: 'none',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#333',
            },
            display: 'flex',
            alignItems: 'center',
          }}
          startIcon={<ReplyOutlinedIcon sx={{ transform: 'scaleX(-1)' }} />}
          onClick={handleShareClick}
        >
          Share Card
        </Button>
      </Box>

      <ShareYourCardModal
        open={shareModalOpen}
        onClose={() => setShareModalOpen(false)}
        cardId={card?._id}
      />


    </Box>
  );
};

export default CardComponent;
